import {
  extractReferencesFromResponse,
  understandFetchError,
  understandSubmitError,
} from "shared/api";

export function defaultInitialState() {
  return {
    currentPageData: {},
    isFetching: false,
    isSubmitting: false,
    fetchErrorCode: null,
    fetchErrorMessages: [],
    submitErrorCode: null,
    submitErrorFields: [],
    submitErrorMessages: [],
    submitSuccess: false,
    submitSuccessMessage: null,
  };
}

// /
// Fetching a screen's data

export function defaultFetchRequestState() {
  return {
    currentPageData: {},
    isFetching: true,
    fetchErrorCode: null,
    fetchErrorMessages: [],
    isSubmitting: false,
    submitErrorCode: null,
    submitErrorFields: [],
    submitErrorMessages: [],
    submitSuccess: false,
    submitSuccessMessage: null,
  };
}

// Please note: This completely replaces app.currentPageData
export function defaultFetchReceiveSuccessState(
  state,
  action,
  resourceNames = [],
) {
  return {
    isFetching: false,
    currentPageData: extractReferencesFromResponse(
      action.payload,
      resourceNames,
    ),
  };
}

export function defaultFetchReceiveErrorState(state, action) {
  const error = understandFetchError(action.payload);
  if (error.wayToHandle === "display-to-user") {
    return {
      isFetching: false,
      fetchErrorCode: error.code,
      fetchErrorMessages: error.messages,
    };
  }
  return {
    isFetching: false,
  };
}

// /
// Submitting a form

export function defaultSubmitRequestState() {
  return {
    isSubmitting: true,
    submitErrorCode: null,
    submitErrorMessages: [],
    submitErrorFields: [],
    submitSuccess: false,
    submitSuccessMessage: null,
  };
}

// Please note: This adds to app.currentPageData
// (instead of replacing it)
export function defaultSubmitReceiveSuccessState(
  state,
  action,
  resourceNames = [],
  successMessage = "Erfolgreich",
) {
  return {
    isSubmitting: false,
    currentPageData: {
      ...state.currentPageData,
      ...extractReferencesFromResponse(action.payload, resourceNames),
    },
    submitSuccess: true,
    submitSuccessMessage: successMessage,
  };
}

export function defaultSubmitReceiveSuccessStateWithoutData(
  state,
  action,
  successMessage = "Erfolgreich",
) {
  return {
    isSubmitting: false,
    submitSuccess: true,
    submitSuccessMessage: successMessage,
  };
}

export function defaultSubmitReceiveErrorState(
  state,
  action,
  resourceName = null,
) {
  const error = understandSubmitError(
    action.payload,
    action.meta,
    resourceName,
  );

  if (error.wayToHandle === "display-to-user") {
    return {
      isSubmitting: false,
      submitErrorCode: error.code,
      submitErrorMessages: error.messages,
      submitErrorFields: error.fields || [],
      submitSuccess: false,
      submitSuccessMessage: null,
    };
  }
  return {
    isSubmitting: false,
    submitSuccess: false,
    submitSuccessMessage: null,
  };
}
